export default "__VITE_ASSET__oxl571jQ__"